import z from "zod"

// --- Zod Schema ---
export const relacaoPagamentosSchema = z.object({
  fiscal_note_url: z.any().optional(),
  id_staff_contract: z.string().min(1, "Selecione o contrato"),
  budget_item_id: z.string().min(1, "Selecione o sub-item do orçamento"),
  project: z.string().min(1, "Selecione o projeto"),
  salic: z.string().min(1, "SALIC obrigatório"),
  proponent: z.string().min(1, "Proponente obrigatório"),
  bank: z.string().min(1, "Banco obrigatório"),
  agency: z.string().min(1, "Agência obrigatória"),
  account: z.string().min(1, "Conta obrigatória"),
  creditor: z.string().min(1, "Credor obrigatório"),
  cpfCnpj: z.string().min(1, "CPF/CNPJ obrigatório"),
  payment_date: z.date().or(z.string().min(1, "Data obrigatória")),
  emission_type: z.string().min(1, "Tipo obrigatório"),
  emission_number: z.string().min(1, "Número obrigatório"),
  emission_date: z.date().or(z.string().min(1, "Data obrigatória")),
  amount: z.string().min(1, "Valor obrigatório"),
  notes: z.string().optional(),
})

export type RelacaoPagamentosFormData = z.infer<typeof relacaoPagamentosSchema>